import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";

const CommunicationModal = ({ isOpen, onClose, student }) => {
  const [communications, setCommunications] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const token = localStorage.getItem("token");
  const currentUser = localStorage.getItem("userName") || "Teacher";

  const fetchCommunications = async () => {
    try {
      const response = await get(
        `CommonSettings/GetTeacherParentCommunicationByStudentIdAsync?studentId=${student.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCommunications(response);
    } catch (error) {
      console.error("Error fetching communications:", error);
      toast.error("Failed to load communications.");
    }
  };

  useEffect(() => {
    if (student) {
      fetchCommunications();
    }
  }, [student]);

  const onSubmit = async (data) => {
    if (!data.remarks || data.remarks.trim() === "") {
      toast.error("Remarks are required.");
      return;
    }

    if (!student?.id || student.id <= 0) {
      toast.error("Invalid student ID.");
      return;
    }

    const newCommunication = {
      id: 0,
      studentID: student.id,
      teacherName: currentUser,
      parentName: "Parent",
      createdOn: new Date().toISOString(),
      createdBy: currentUser,
      remarks: data.remarks.trim(),
      actionTaken: "",
    };

    console.log("Sending payload:", newCommunication);

    try {
      const response = await post(
        `CommonSettings/AddTeacherParentCommunicationAsync`,
        newCommunication,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        }
      );

      if (response.isSuccess) {
        toast.success("Communication added successfully!");
        reset();
        fetchCommunications();
      } else {
        console.error("API error response:", response);
        toast.error(response.message || "Failed to add communication.");
      }
    } catch (error) {
      console.error(
        "Error adding communication:",
        error.response?.data || error.message
      );
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.title ||
          "An error occurred while adding communication."
      );
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Dimmed backdrop
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1050,
      }}
      onClick={onClose} // Optional: Close modal on backdrop click
    >
      <div
        className="modal-dialog"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <div
          className="modal-content"
          style={{
            borderRadius: "15px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title">
              Communication for {student.firstName} {student.lastName}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body" style={{ padding: "20px" }}>
            <div
              className="communication-list mb-3"
              style={{
                maxHeight: "200px",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {communications.length > 0 ? (
                communications.map((comm, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor:
                        comm.createdBy === currentUser ? "#dcf8c6" : "#f1f1f1",
                      borderRadius: "10px",
                      padding: "10px",
                      marginBottom: "10px",
                      maxWidth: "80%",
                      alignSelf:
                        comm.createdBy === currentUser
                          ? "flex-end"
                          : "flex-start",
                    }}
                  >
                    <p style={{ marginBottom: "5px", fontWeight: "bold" }}>
                      {comm.createdBy} (
                      {new Date(comm.createdOn).toLocaleString()})
                    </p>
                    <p style={{ marginBottom: "0" }}>{comm.remarks}</p>
                    {comm.actionTaken && (
                      <p
                        style={{
                          marginTop: "5px",
                          fontStyle: "italic",
                          color: "#666",
                        }}
                      >
                        Action: {comm.actionTaken}
                      </p>
                    )}
                  </div>
                ))
              ) : (
                <p style={{ textAlign: "center", color: "#888" }}>
                  No communications yet.
                </p>
              )}
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3">
                <label htmlFor="remarks" className="form-label">
                  Add New Remarks
                </label>
                <textarea
                  className={`form-control ${
                    errors.remarks ? "is-invalid" : ""
                  }`}
                  id="remarks"
                  rows="3"
                  {...register("remarks", { required: "Remarks are required" })}
                  placeholder="Enter your remarks here"
                ></textarea>
                {errors.remarks && (
                  <div className="invalid-feedback">
                    {errors.remarks.message}
                  </div>
                )}
              </div>
              <button type="submit" className="btn btn-primary">
                Add Communication
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunicationModal;
